<template>
  <div>
    <NavBar/>
    <section id="services" class="section is-medium" style="background-color: #EFF4F7;">
      <div class="container">
        <h1 v-html="$t('legalNotice_main_title')" class="title is-1 is-spaced has-text-grey"></h1>
        <h2 v-html="$t('legalNotice_title')" class="title is-2"></h2>
        <p v-html="$t('legalNotice_text')" style="margin-bottom: 25px;"></p>
        <h3 v-html="$t('legalNotice_liability_content_title')" class="title is-3"></h3>
        <p v-html="$t('legalNotice_liability_content_text')" style="margin-bottom: 25px;"></p>
        <h3 v-html="$t('legalNotice_liability_link_title')" class="title is-3"></h3>
        <p v-html="$t('legalNotice_liability_link_text')" style="margin-bottom: 25px;"></p>
        <h3 v-html="$t('legalNotice_copyright_notice_title')" class="title is-3"></h3>
        <p v-html="$t('legalNotice_copyright_notice_text')" style="margin-bottom: 25px;"></p>
      </div>
    </section>
    <Footer/>
  </div>
</template>
<script>
import NavBar from '@/components/NavBar.vue';
import Footer from '@/components/Footer.vue';

export default {
  name: 'PrivacyPolicy',
  components: {
    NavBar,
    Footer,
  },
};
</script>
